"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonoChannel = exports.Channel = exports.createBroadcastChannel = exports.MessageType = void 0;
var broadcast_channel_1 = require("broadcast-channel");
var MessageType;
(function (MessageType) {
    MessageType["ForceSend"] = "force-send";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
function createBroadcastChannel() {
    return new broadcast_channel_1.BroadcastChannel('bf-sdk');
}
exports.createBroadcastChannel = createBroadcastChannel;
var Channel = (function () {
    function Channel(channel, logger, session) {
        var _this = this;
        this.channel = channel;
        this.logger = logger;
        this.session = session;
        this.leader = false;
        this.onForceSendCb = function () { };
        this.sessionsStatus = {};
        this.channel.onmessage = function (msg) { return _this.handleMessage(msg); };
        this.elector = broadcast_channel_1.createLeaderElection(this.channel, {
            fallbackInterval: 2000,
            responseTime: 1000,
        });
        this.leaderPromise = this.elector.awaitLeadership();
        this.leaderPromise.then(function () {
            _this.logger.log("Now I'm the leader. \uD83D\uDCAA");
            _this.leader = true;
        });
    }
    Channel.prototype.handleMessage = function (msg) {
        switch (msg.type) {
            case MessageType.ForceSend:
                if (this.leader) {
                    this.onForceSendCb();
                }
                break;
            case MessageType.Ping:
                if (msg.toSessionUUID === this.session.getUUID()) {
                    this.channel.postMessage({
                        type: MessageType.Pong,
                        fromSessionUUID: msg.toSessionUUID,
                        toSessionUUID: msg.fromSessionUUID,
                    });
                }
                break;
            case MessageType.Pong:
                if (msg.toSessionUUID === this.session.getUUID()) {
                    this.sessionsStatus[msg.fromSessionUUID] = true;
                }
                break;
        }
    };
    Channel.prototype.isLeader = function () {
        return this.leader;
    };
    Channel.prototype.notifyForceSend = function () {
        if (this.leader) {
            this.onForceSendCb();
        }
        else {
            this.channel.postMessage({ type: MessageType.ForceSend });
        }
    };
    Channel.prototype.onForceSend = function (cb) {
        this.onForceSendCb = cb;
    };
    Channel.prototype.onHasBecomeLeader = function () {
        return this.leaderPromise;
    };
    Channel.prototype.isSessionActive = function (sessionUUID) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.session.getUUID() === sessionUUID) {
                    return [2, true];
                }
                return [2, new Promise(function (resolve) {
                        var timeout = 250;
                        _this.sessionsStatus[sessionUUID] = false;
                        _this.channel.postMessage({
                            type: MessageType.Ping,
                            fromSessionUUID: _this.session.getUUID(),
                            toSessionUUID: sessionUUID,
                        });
                        setTimeout(function () { return resolve(_this.sessionsStatus[sessionUUID]); }, timeout);
                    })];
            });
        });
    };
    return Channel;
}());
exports.Channel = Channel;
var MonoChannel = (function () {
    function MonoChannel(session) {
        this.session = session;
        this.onForceSendCb = function () { };
        this.leaderPromise = Promise.resolve();
    }
    MonoChannel.prototype.isLeader = function () {
        return true;
    };
    MonoChannel.prototype.isSessionActive = function (sessionUUID) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.session.getUUID() === sessionUUID];
            });
        });
    };
    MonoChannel.prototype.notifyForceSend = function () {
        this.onForceSendCb();
    };
    MonoChannel.prototype.onForceSend = function (cb) {
        this.onForceSendCb = cb;
    };
    MonoChannel.prototype.onHasBecomeLeader = function () {
        return this.leaderPromise;
    };
    return MonoChannel;
}());
exports.MonoChannel = MonoChannel;
